import React from 'react';
import BooleanRadioButtons from '../../components/BooleanRadioButtons';
import Card from '../../components/card';
import { BorrowerCard, CoborrowerCard } from '../card-lenses';

const getPossessivePronoun = (id) => (id === 'borrower' ? 'your' : 'their');

const EmploymentLength = ({ model, onChange, id, ...cardProps }) => {
  const onEmploymentLengthChange = onChange.bind(null, 'twoYearsAtCurrentJob');
  return (
    <Card
      title={`How long have ${
        id === 'borrower' ? 'you' : 'they'
      } been earning bonus/commission income from ${getPossessivePronoun(id)} current employer?`}
      {...cardProps}
    >
      <p>
        This impacts how lenders evaluate the stability of {getPossessivePronoun(id)}{' '}
        bonus/commission income.
      </p>
      <BooleanRadioButtons
        name="twoYearsAtCurrentJob"
        value={model.get('twoYearsAtCurrentJob')}
        onChange={onEmploymentLengthChange}
        trueLabel="More than two years"
        falseLabel="Less than two years"
      />
    </Card>
  );
};

EmploymentLength.completed = ({ model }) => model.get('twoYearsAtCurrentJob') != undefined;

export const PrimaryBorrowerEmploymentLength = BorrowerCard(
  EmploymentLength,
  'PrimaryBorrowerEmploymentLength',
  {
    id: 'borrower'
  }
);

export const CoborrowerEmploymentLength = CoborrowerCard(
  EmploymentLength,
  'CoborrowerEmploymentLength',
  {
    id: 'coborrower'
  }
);



// WEBPACK FOOTER //
// ./src/cards/bonus-cards/employment-length.js